import LessonPage from "./LessonPage";

const page = LessonPage;
export default page;
